import { render, staticRenderFns } from "./ApprovalRemarks.vue?vue&type=template&id=7e19d4db"
import script from "./ApprovalRemarks.vue?vue&type=script&lang=js"
export * from "./ApprovalRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports